/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsDisableWebhooks } from "../funcs/organizationsDisableWebhooks.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DisableWebhooksRequest,
  DisableWebhooksSecurity,
} from "../models/operations/disablewebhooks.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DisableWebhooksMutationVariables = {
  request?: DisableWebhooksRequest | undefined;
  security?: DisableWebhooksSecurity | undefined;
  options?: RequestOptions;
};

export type DisableWebhooksMutationData = void;

export type DisableWebhooksMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * disableWebhooks organizations
 *
 * @remarks
 * Disable  webhooks for the active organization.
 */
export function useDisableWebhooksMutation(
  options?: MutationHookOptions<
    DisableWebhooksMutationData,
    DisableWebhooksMutationError,
    DisableWebhooksMutationVariables
  >,
): UseMutationResult<
  DisableWebhooksMutationData,
  DisableWebhooksMutationError,
  DisableWebhooksMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDisableWebhooksMutation(client, options),
    ...options,
  });
}

export function mutationKeyDisableWebhooks(): MutationKey {
  return ["@gram/client", "organizations", "disableWebhooks"];
}

export function buildDisableWebhooksMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DisableWebhooksMutationVariables,
  ) => Promise<DisableWebhooksMutationData>;
} {
  return {
    mutationKey: mutationKeyDisableWebhooks(),
    mutationFn: function disableWebhooksMutationFn({
      request,
      security,
      options,
    }): Promise<DisableWebhooksMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(organizationsDisableWebhooks(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
